module.exports = __webpack_public_path__ + "img/store_FB_brown.87b1f3ea.svg";